import Api from '@common/services/api';

export const togglePin = async (orgId: string, conversationId: string, shouldPin: boolean) => {
  return Api.post(`/v3/organisations/${orgId}/conversations/${conversationId}/${shouldPin ? 'pin' : 'unpin'}`);
};
